/**
 * Frontend Geocoding Utility
 * Calls our own backend to geocode city/state.
 * The Mapbox token stays on the server — never exposed to the browser.
 */

import apiClient from '../api/client';

/**
 * Geocode a city and state to get latitude and longitude.
 * Calls GET /api/geocode?city=X&state=Y on our backend.
 *
 * @param {string} city - City name (e.g. "Hartford")
 * @param {string} state - State abbreviation (e.g. "CT")
 * @returns {Object} { latitude, longitude } or throws error with user-friendly message
 */
export const geocodeCityState = async (city, state) => {
  if (!city || !state) {
    throw new Error('City and state are required');
  }

  try {
    const response = await apiClient.get('/geocode', {
      params: { city: city.trim(), state: state.trim().toUpperCase() }
    });

    if (response.data.success) {
      return {
        latitude: response.data.latitude,
        longitude: response.data.longitude
      };
    }

    throw new Error(response.data.error || 'Geocoding failed');
  } catch (err) {
    // If the backend returned a specific error message, use it
    if (err.response?.data?.error) {
      throw new Error(err.response.data.error);
    }
    throw err;
  }
};
